export const MISSING_PROPERTY_PLACEHOLDER = '-';

export const getPropertyStringSafe = (
  properties: unknown,
  key: string
): string => {
  if (
    properties &&
    typeof properties === 'object' &&
    key in properties &&
    typeof (properties as Record<string, unknown>)[key] === 'string'
  ) {
    return (properties as Record<string, unknown>)[key] as string;
  }
  return MISSING_PROPERTY_PLACEHOLDER;
};
